import { Loader } from "@athena/forge";
import BaseContainer from "./BaseContainer";

export const LoadingContainer = (): React.JSX.Element => {
  return <BaseContainer childElement={<Loader loading={true} />} />;
};
